export interface GetApiConfigParams {
    apiToken?: string;
    validationToken?: string;
  }
  
  export interface GetApiConfigReturnType {
    headers: {
      "Content-Type": string;
      "X-IBM-Client-Id": string;
      "X-IBM-Client-Secret": string;
      "x-fapi-uuid": string;
      enckey: string;
      Authorization: string;
    };
  }

  export const getSuperMoneyAccountId = (): string | undefined => {
    try {
      const bridgeDataRaw = localStorage.getItem("bridgeData") || "{}";
      const bridgeData = JSON.parse(bridgeDataRaw);
      const accountId = bridgeData?.superMoneyAccountId;
      return typeof accountId === "string" && accountId.trim() ? accountId.trim() : undefined;
    } catch {
      return undefined;
    }
  };

  export const getApiConfig = ({
    apiToken,
    validationToken
  }: GetApiConfigParams): GetApiConfigReturnType => {
    const headers: any = {
      "x-fapi-uuid": crypto.randomUUID(),
      "x-issuer-id": "54321"
    };
  
    if (!!validationToken) {
      headers.Authorization = `Bearer ${validationToken}`;
    }

  
    return { headers };
  };
  
  export function extractKeyFromCrypto(cryptoData: any): Uint8Array {
    const keyBytes = new Uint8Array(cryptoData.sigBytes);
  
    for (let i = 0; i < cryptoData.words.length; i++) {
      const word = cryptoData.words[i];
  
      // Extract each byte from the 32-bit word
      for (let j = 0; j < 4; j++) {
        const bytePosition = i * 4 + j;
        const byteValue = (word >> (j * 8)) & 0xff;
        keyBytes[bytePosition] = byteValue;
      }
    }
  
    return keyBytes;
  }
  